export class BillingDoIt {
    public ids?: (number | undefined)[];
    public date?: Date | string;
    constructor(billingDoIt?: BillingDoIt) {
        this.ids = billingDoIt?.ids || [];
        this.date = billingDoIt?.date;
    }
}
